import {
  EDIT_PROFILE_FAILED,
  EDIT_PROFILE_START,
  EDIT_PROFILE_SUCCESS,
} from 'constants/action-types/profiles/editProfile';

export default (state, { type, payload }) => {
  switch (type) {
    case EDIT_PROFILE_START:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          loading: true,
          error: null,
        },
      };
    case EDIT_PROFILE_FAILED:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          error: payload,
          loading: false,
        },
      };
    case EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          loading: false,
        },
      };
    default:
      return null;
  }
};
